// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Generated from productTypes table on 2026-10-27
// Run `bun run generate:types` to regenerate

import { PRODUCT_TYPE_CONDITIONS as SHARED_PRODUCT_TYPE_CONDITIONS } from '@shared/generated/productConditions'
import { isMemberOf } from '@shared/validation/narrow'

export interface ProductType {
  slug: string
  displayName: string
  pluralDisplayName: string
  description: string
  displayOrder: number
  isFeatured: boolean
  iconUrl: string | null
}

export interface AccessoryType {
  slug: string
  displayName: string
  pluralDisplayName: string
  description: string
  displayOrder: number
  iconUrl: string | null
  parentTypeSlug: string
}

export type RfqFlow = 'buy' | 'sell' | 'recycle'

export type FieldImportance = 'required' | 'recommended' | 'optional'

export interface FieldDefinition {
  name: string
  type: string
  label: string
  description?: string
  required?: boolean
  options?: Array<{ label: string; value: string }>
  allowCustom?: boolean
  unit?: string
  validation?: { min?: number; max?: number; step?: number }
  showWhen?: Record<string, string>
  group?: string
  showInFlows?: RfqFlow[]
  requiredInFlows?: RfqFlow[]
  importance?: FieldImportance
  fileConfig?: { accept: string[]; maxSizeMB: number; category: string }
}

export const PRODUCT_TYPE_SLUGS = [
  'pallets',
  'gaylord-boxes',
  'ibc-totes',
  'metal-drums',
  'plastic-drums',
  'wood-crates',
  'plastic-pallets',
  'wooden-spools',
  'plastic-crates',
  'bulk-bags',
  'cardboard-bales',
  'shipping-boxes',
  'lumber',
  'equipment',
  'moving-boxes',
  'ibc-valves',
  'ibc-caps',
  'ibc-adapters',
  'ibc-gaskets',
  'ibc-stands',
  'ibc-heaters',
  'ibc-liners',
  'drum-pumps',
  'drum-faucets',
  'drum-bungs',
  'drum-liners',
  'drum-covers',
  'drum-heaters',
  'drum-funnels',
  'gaylord-liners',
  'gaylord-covers',
  'gaylord-lids',
  'bulk-bag-liners',
  'bulk-bag-lifters',
  'pallet-covers',
  'pallet-corner-protectors',
  'pallet-deck-boards',
  'pallet-stringers',
  'pallet-blocks',
  'pallet-lead-boards',
  'lumber-nails',
  'lumber-screws',
  'pallet-staples',
  'wire-baskets',
  'metal-cages',
  'stretch-wrap',
  'strapping',
  'pallet-riser',
  'ibc-lids',
  'drum-lids',
  'fiber-drums',
] as const

export type ProductTypeSlug = (typeof PRODUCT_TYPE_SLUGS)[number]

export const MAIN_PRODUCT_TYPE_SLUGS = [
  'pallets',
  'gaylord-boxes',
  'ibc-totes',
  'metal-drums',
  'plastic-drums',
  'fiber-drums',
  'wood-crates',
  'plastic-pallets',
  'wooden-spools',
  'plastic-crates',
  'bulk-bags',
  'cardboard-bales',
  'shipping-boxes',
  'lumber',
  'equipment',
  'moving-boxes',
  'wire-baskets',
  'metal-cages',
  'stretch-wrap',
  'strapping',
  'pallet-riser',
] as const

export type MainProductTypeSlug = (typeof MAIN_PRODUCT_TYPE_SLUGS)[number]

export const ACCESSORY_TYPE_SLUGS = [
  'ibc-valves',
  'ibc-caps',
  'ibc-adapters',
  'ibc-gaskets',
  'ibc-stands',
  'ibc-heaters',
  'ibc-liners',
  'drum-pumps',
  'drum-faucets',
  'drum-bungs',
  'drum-liners',
  'drum-covers',
  'drum-heaters',
  'drum-funnels',
  'gaylord-liners',
  'gaylord-covers',
  'gaylord-lids',
  'bulk-bag-liners',
  'bulk-bag-lifters',
  'pallet-covers',
  'pallet-corner-protectors',
  'pallet-deck-boards',
  'pallet-stringers',
  'pallet-blocks',
  'pallet-lead-boards',
  'lumber-nails',
  'lumber-screws',
  'pallet-staples',
  'ibc-lids',
  'drum-lids',
] as const

export type AccessoryTypeSlug = (typeof ACCESSORY_TYPE_SLUGS)[number]

export const FEATURED_SLUGS: readonly MainProductTypeSlug[] = ["pallets","gaylord-boxes","ibc-totes","bulk-bags"] as const

export {
  getConditionsForProductType as getConditionsForType,
  getConditionLabel,
} from '@shared/generated/productConditions'

// prettier-ignore
export const PRODUCT_TYPE_CONDITIONS: Partial<Record<ProductTypeSlug, readonly { label: string; value: string }[]>> = SHARED_PRODUCT_TYPE_CONDITIONS

// prettier-ignore
export const PRODUCT_TYPES: readonly ProductType[] = [
  {
    "slug": "pallets",
    "displayName": "Pallets",
    "pluralDisplayName": "Pallets",
    "description": "Standard and non-standard wooden pallets for shipping and storage",
    "displayOrder": 1,
    "isFeatured": true,
    "iconUrl": "https://api.repackify.com/api/storage/243dd53d-32ec-4221-a67e-31a98d6b2fff"
  },
  {
    "slug": "gaylord-boxes",
    "displayName": "Gaylord Boxes",
    "pluralDisplayName": "Gaylord Boxes",
    "description": "Large bulk cardboard boxes used for industrial storage and shipping",
    "displayOrder": 2,
    "isFeatured": true,
    "iconUrl": "https://api.repackify.com/api/storage/2079ce30-1696-4071-92d1-750063883dfd"
  },
  {
    "slug": "ibc-totes",
    "displayName": "IBC Totes",
    "pluralDisplayName": "IBC Totes",
    "description": "Intermediate bulk containers for liquid and dry goods",
    "displayOrder": 3,
    "isFeatured": true,
    "iconUrl": "https://api.repackify.com/api/storage/4661cc97-4d6b-4d6c-98cc-d328b6609544"
  },
  {
    "slug": "metal-drums",
    "displayName": "Metal Drums",
    "pluralDisplayName": "Metal Drums",
    "description": "Steel drums for industrial liquid and solid storage",
    "displayOrder": 4,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/8b55e045-af47-4d20-9c2b-22795637711b"
  },
  {
    "slug": "plastic-drums",
    "displayName": "Plastic Drums",
    "pluralDisplayName": "Plastic Drums",
    "description": "HDPE plastic drums for chemical and food-grade storage",
    "displayOrder": 5,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/62c9e1bd-68a7-44a7-b783-52a70b1214e3"
  },
  {
    "slug": "fiber-drums",
    "displayName": "Fiber Drums",
    "pluralDisplayName": "Fiber Drums",
    "description": "Fibreboard drums for powders, pellets and other dry goods",
    "displayOrder": 5.5,
    "isFeatured": false,
    "iconUrl": null
  },
  {
    "slug": "wood-crates",
    "displayName": "Wood Crates",
    "pluralDisplayName": "Wood Crates",
    "description": "Heavy-duty wooden crates for industrial and export shipping",
    "displayOrder": 6,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/1cd64326-4e06-47e7-a752-2726543afc4a"
  },
  {
    "slug": "plastic-pallets",
    "displayName": "Plastic Pallets",
    "pluralDisplayName": "Plastic Pallets",
    "description": "Durable plastic pallets for reusable shipping applications",
    "displayOrder": 7,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/5f6d2929-b399-430d-b760-6d6d6fc50aad"
  },
  {
    "slug": "wooden-spools",
    "displayName": "Wooden Spools",
    "pluralDisplayName": "Wooden Spools",
    "description": "Industrial wooden reels and spools for cable and wire",
    "displayOrder": 8,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/64c1b071-4394-4d64-a786-94c1869eca6d"
  },
  {
    "slug": "plastic-crates",
    "displayName": "Plastic Crates",
    "pluralDisplayName": "Plastic Crates",
    "description": "Stackable plastic crates for distribution and storage",
    "displayOrder": 9,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/88047e73-c05a-44f4-a2f6-259ba67952bd"
  },
  {
    "slug": "bulk-bags",
    "displayName": "Bulk Bags",
    "pluralDisplayName": "Bulk Bags",
    "description": "FIBC super sacks for transporting dry bulk materials",
    "displayOrder": 10,
    "isFeatured": true,
    "iconUrl": "https://api.repackify.com/api/storage/2f18d64e-35aa-4490-9a8f-9b06f4ee206e"
  },
  {
    "slug": "cardboard-bales",
    "displayName": "Cardboard Bales",
    "pluralDisplayName": "Cardboard Bales",
    "description": "Baled OCC and mixed cardboard for recycling",
    "displayOrder": 11,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/aebc05ae-5689-4187-b5af-e036a25f09e7"
  },
  {
    "slug": "shipping-boxes",
    "displayName": "Shipping Boxes",
    "pluralDisplayName": "Shipping Boxes",
    "description": "Corrugated cardboard boxes for parcel and freight shipping",
    "displayOrder": 12,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/e8f8fe90-365e-43f2-b83c-655f64909893"
  },
  {
    "slug": "lumber",
    "displayName": "Lumber",
    "pluralDisplayName": "Lumber",
    "description": "Reclaimed and surplus dimensional lumber and plywood",
    "displayOrder": 13,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/fa4dec84-4610-4b28-a339-b50201655de2"
  },
  {
    "slug": "equipment",
    "displayName": "Equipment",
    "pluralDisplayName": "Equipment",
    "description": "Buy and sell used equipment",
    "displayOrder": 14,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/602f6727-845b-4cad-b27d-cf14979aeac6"
  },
  {
    "slug": "moving-boxes",
    "displayName": "Moving Boxes",
    "pluralDisplayName": "Moving Boxes",
    "description": "Used moving and storage boxes in good condition",
    "displayOrder": 15,
    "isFeatured": false,
    "iconUrl": "https://api.repackify.com/api/storage/f3b2dfac-9d5c-43df-acec-cfa11b9e31b7"
  },
  {
    "slug": "wire-baskets",
    "displayName": "Wire Basket",
    "pluralDisplayName": "Wire Baskets",
    "description": "Steel wire baskets and containers for industrial use",
    "displayOrder": 15,
    "isFeatured": false,
    "iconUrl": null
  },
  {
    "slug": "metal-cages",
    "displayName": "Metal Cage",
    "pluralDisplayName": "Metal Cages",
    "description": "Wire mesh security cages and stillages for parts storage",
    "displayOrder": 16,
    "isFeatured": false,
    "iconUrl": null
  },
  {
    "slug": "stretch-wrap",
    "displayName": "Stretch Wrap",
    "pluralDisplayName": "Stretch Wrap",
    "description": "Surplus or returned stretch film and pallet wrap",
    "displayOrder": 18,
    "isFeatured": false,
    "iconUrl": null
  },
  {
    "slug": "strapping",
    "displayName": "Strapping",
    "pluralDisplayName": "Strapping",
    "description": "Poly and steel banding strapping for securing loads",
    "displayOrder": 19,
    "isFeatured": false,
    "iconUrl": null
  },
  {
    "slug": "pallet-riser",
    "displayName": "Pallet Riser",
    "pluralDisplayName": "Pallet Risers",
    "description": "Stackable risers and legs to elevate pallets off the floor",
    "displayOrder": 20,
    "isFeatured": false,
    "iconUrl": null
  }
]

// prettier-ignore
export const ACCESSORY_TYPES: readonly AccessoryType[] = [
  {
    "slug": "ibc-valves",
    "displayName": "IBC Valves",
    "pluralDisplayName": "IBC Valves",
    "description": "Ball, butterfly, and gate valves for IBC drainage",
    "displayOrder": 101,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-pumps",
    "displayName": "Drum Pumps",
    "pluralDisplayName": "Drum Pumps",
    "description": "Electric, rotary, siphon, and hand pumps for drums",
    "displayOrder": 101,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "gaylord-liners",
    "displayName": "Gaylord Liners",
    "pluralDisplayName": "Gaylord Liners",
    "description": "Poly liners for gaylord moisture protection",
    "displayOrder": 101,
    "iconUrl": null,
    "parentTypeSlug": "gaylord-boxes"
  },
  {
    "slug": "bulk-bag-liners",
    "displayName": "Bulk Bag Liners",
    "pluralDisplayName": "Bulk Bag Liners",
    "description": "Poly liners for bulk bag fine materials protection",
    "displayOrder": 101,
    "iconUrl": null,
    "parentTypeSlug": "bulk-bags"
  },
  {
    "slug": "pallet-covers",
    "displayName": "Pallet Covers",
    "pluralDisplayName": "Pallet Covers",
    "description": "Clear, thermal, and anti-static covers for pallets",
    "displayOrder": 101,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "ibc-caps",
    "displayName": "IBC Caps",
    "pluralDisplayName": "IBC Caps",
    "description": "Replacement fill caps and dust caps for IBC totes",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-faucets",
    "displayName": "Drum Faucets",
    "pluralDisplayName": "Drum Faucets",
    "description": "Dispensing faucets and spigots for drums",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "gaylord-covers",
    "displayName": "Gaylord Covers",
    "pluralDisplayName": "Gaylord Covers",
    "description": "Elastic, clear, and heavy duty covers for gaylords",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "gaylord-boxes"
  },
  {
    "slug": "bulk-bag-lifters",
    "displayName": "Bulk Bag Lifters",
    "pluralDisplayName": "Bulk Bag Lifters",
    "description": "Forklift and hoist lifting attachments for bulk bags",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "bulk-bags"
  },
  {
    "slug": "pallet-corner-protectors",
    "displayName": "Corner Protectors",
    "pluralDisplayName": "Corner Protectors",
    "description": "Edge and corner protection for palletized loads",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "ibc-lids",
    "displayName": "IBC Lid",
    "pluralDisplayName": "IBC Lids",
    "description": "Replacement lids and caps for IBC totes",
    "displayOrder": 102,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "ibc-adapters",
    "displayName": "IBC Adapters",
    "pluralDisplayName": "IBC Adapters",
    "description": "Garden hose, camlock, and reducing adapters for IBC totes",
    "displayOrder": 103,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-bungs",
    "displayName": "Drum Bungs",
    "pluralDisplayName": "Drum Bungs",
    "description": "Plugs, caps, and seals for drum openings",
    "displayOrder": 103,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "gaylord-lids",
    "displayName": "Gaylord Lids",
    "pluralDisplayName": "Gaylord Lids",
    "description": "Replacement lids for gaylord boxes",
    "displayOrder": 103,
    "iconUrl": null,
    "parentTypeSlug": "gaylord-boxes"
  },
  {
    "slug": "drum-lids",
    "displayName": "Drum Lid",
    "pluralDisplayName": "Drum Lids",
    "description": "Replacement lids and bungs for metal and plastic drums",
    "displayOrder": 103,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "ibc-gaskets",
    "displayName": "IBC Gaskets",
    "pluralDisplayName": "IBC Gaskets",
    "description": "Replacement seals and gaskets for IBC totes",
    "displayOrder": 104,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-liners",
    "displayName": "Drum Liners",
    "pluralDisplayName": "Drum Liners",
    "description": "LDPE liners for drum corrosion protection",
    "displayOrder": 104,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "ibc-stands",
    "displayName": "IBC Stands",
    "pluralDisplayName": "IBC Stands",
    "description": "Steel stands for elevated IBC positioning",
    "displayOrder": 105,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-covers",
    "displayName": "Drum Covers",
    "pluralDisplayName": "Drum Covers",
    "description": "Dust covers and lids for drums",
    "displayOrder": 105,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "ibc-heaters",
    "displayName": "IBC Heaters",
    "pluralDisplayName": "IBC Heaters",
    "description": "Blanket heaters for IBC temperature control",
    "displayOrder": 106,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-heaters",
    "displayName": "Drum Heaters",
    "pluralDisplayName": "Drum Heaters",
    "description": "Band and wrap heaters for drums",
    "displayOrder": 106,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "ibc-liners",
    "displayName": "IBC Liners",
    "pluralDisplayName": "IBC Liners",
    "description": "Poly liners for IBC contamination protection",
    "displayOrder": 107,
    "iconUrl": null,
    "parentTypeSlug": "ibc-totes"
  },
  {
    "slug": "drum-funnels",
    "displayName": "Drum Funnels",
    "pluralDisplayName": "Drum Funnels",
    "description": "Pour funnels with screens for drums",
    "displayOrder": 107,
    "iconUrl": null,
    "parentTypeSlug": "metal-drums"
  },
  {
    "slug": "pallet-deck-boards",
    "displayName": "Pallet Deck Boards",
    "pluralDisplayName": "Pallet Deck Boards",
    "description": "Top and bottom deck boards for pallet construction",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "pallet-stringers",
    "displayName": "Pallet Stringers",
    "pluralDisplayName": "Pallet Stringers",
    "description": "Notched stringers for stringer-style pallets",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "pallet-blocks",
    "displayName": "Pallet Blocks",
    "pluralDisplayName": "Pallet Blocks",
    "description": "Blocks for block-style pallets",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "pallet-lead-boards",
    "displayName": "Pallet Lead Boards",
    "pluralDisplayName": "Pallet Lead Boards",
    "description": "End boards (lead/trail boards) for pallets",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  },
  {
    "slug": "lumber-nails",
    "displayName": "Lumber Nails",
    "pluralDisplayName": "Lumber Nails",
    "description": "Nails for lumber and pallet assembly",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "lumber"
  },
  {
    "slug": "lumber-screws",
    "displayName": "Lumber Screws",
    "pluralDisplayName": "Lumber Screws",
    "description": "Screws for lumber and pallet work",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "lumber"
  },
  {
    "slug": "pallet-staples",
    "displayName": "Pallet Staples",
    "pluralDisplayName": "Pallet Staples",
    "description": "Staples for pallet assembly",
    "displayOrder": 999,
    "iconUrl": null,
    "parentTypeSlug": "pallets"
  }
]

// prettier-ignore
export const PRODUCT_TYPE_DISPLAY_NAMES: Record<ProductTypeSlug, { singular: string; plural: string }> = {"pallets":{"singular":"Pallets","plural":"Pallets"},"gaylord-boxes":{"singular":"Gaylord Boxes","plural":"Gaylord Boxes"},"ibc-totes":{"singular":"IBC Totes","plural":"IBC Totes"},"metal-drums":{"singular":"Metal Drums","plural":"Metal Drums"},"plastic-drums":{"singular":"Plastic Drums","plural":"Plastic Drums"},"wood-crates":{"singular":"Wood Crates","plural":"Wood Crates"},"plastic-pallets":{"singular":"Plastic Pallets","plural":"Plastic Pallets"},"wooden-spools":{"singular":"Wooden Spools","plural":"Wooden Spools"},"plastic-crates":{"singular":"Plastic Crates","plural":"Plastic Crates"},"bulk-bags":{"singular":"Bulk Bags","plural":"Bulk Bags"},"cardboard-bales":{"singular":"Cardboard Bales","plural":"Cardboard Bales"},"shipping-boxes":{"singular":"Shipping Boxes","plural":"Shipping Boxes"},"lumber":{"singular":"Lumber","plural":"Lumber"},"equipment":{"singular":"Equipment","plural":"Equipment"},"moving-boxes":{"singular":"Moving Boxes","plural":"Moving Boxes"},"ibc-valves":{"singular":"IBC Valves","plural":"IBC Valves"},"ibc-caps":{"singular":"IBC Caps","plural":"IBC Caps"},"ibc-adapters":{"singular":"IBC Adapters","plural":"IBC Adapters"},"ibc-gaskets":{"singular":"IBC Gaskets","plural":"IBC Gaskets"},"ibc-stands":{"singular":"IBC Stands","plural":"IBC Stands"},"ibc-heaters":{"singular":"IBC Heaters","plural":"IBC Heaters"},"ibc-liners":{"singular":"IBC Liners","plural":"IBC Liners"},"drum-pumps":{"singular":"Drum Pumps","plural":"Drum Pumps"},"drum-faucets":{"singular":"Drum Faucets","plural":"Drum Faucets"},"drum-bungs":{"singular":"Drum Bungs","plural":"Drum Bungs"},"drum-liners":{"singular":"Drum Liners","plural":"Drum Liners"},"drum-covers":{"singular":"Drum Covers","plural":"Drum Covers"},"drum-heaters":{"singular":"Drum Heaters","plural":"Drum Heaters"},"drum-funnels":{"singular":"Drum Funnels","plural":"Drum Funnels"},"gaylord-liners":{"singular":"Gaylord Liners","plural":"Gaylord Liners"},"gaylord-covers":{"singular":"Gaylord Covers","plural":"Gaylord Covers"},"gaylord-lids":{"singular":"Gaylord Lids","plural":"Gaylord Lids"},"bulk-bag-liners":{"singular":"Bulk Bag Liners","plural":"Bulk Bag Liners"},"bulk-bag-lifters":{"singular":"Bulk Bag Lifters","plural":"Bulk Bag Lifters"},"pallet-covers":{"singular":"Pallet Covers","plural":"Pallet Covers"},"pallet-corner-protectors":{"singular":"Corner Protectors","plural":"Corner Protectors"},"pallet-deck-boards":{"singular":"Pallet Deck Boards","plural":"Pallet Deck Boards"},"pallet-stringers":{"singular":"Pallet Stringers","plural":"Pallet Stringers"},"pallet-blocks":{"singular":"Pallet Blocks","plural":"Pallet Blocks"},"pallet-lead-boards":{"singular":"Pallet Lead Boards","plural":"Pallet Lead Boards"},"lumber-nails":{"singular":"Lumber Nails","plural":"Lumber Nails"},"lumber-screws":{"singular":"Lumber Screws","plural":"Lumber Screws"},"pallet-staples":{"singular":"Pallet Staples","plural":"Pallet Staples"},"wire-baskets":{"singular":"Wire Basket","plural":"Wire Baskets"},"metal-cages":{"singular":"Metal Cage","plural":"Metal Cages"},"stretch-wrap":{"singular":"Stretch Wrap","plural":"Stretch Wrap"},"strapping":{"singular":"Strapping","plural":"Strapping"},"pallet-riser":{"singular":"Pallet Riser","plural":"Pallet Risers"},"ibc-lids":{"singular":"IBC Lid","plural":"IBC Lids"},"drum-lids":{"singular":"Drum Lid","plural":"Drum Lids"},"fiber-drums":{"singular":"Fiber Drums","plural":"Fiber Drums"}}

// prettier-ignore
export const PRODUCT_TYPE_DIMENSION_TYPES: Record<ProductTypeSlug, '2d' | '3d' | 'capacity' | 'none'> = {"pallets":"none","gaylord-boxes":"none","ibc-totes":"none","metal-drums":"none","plastic-drums":"none","wood-crates":"none","plastic-pallets":"none","wooden-spools":"none","plastic-crates":"none","bulk-bags":"none","cardboard-bales":"none","shipping-boxes":"none","lumber":"none","equipment":"none","moving-boxes":"none","ibc-valves":"none","ibc-caps":"none","ibc-adapters":"none","ibc-gaskets":"none","ibc-stands":"none","ibc-heaters":"none","ibc-liners":"none","drum-pumps":"none","drum-faucets":"none","drum-bungs":"none","drum-liners":"none","drum-covers":"none","drum-heaters":"none","drum-funnels":"none","gaylord-liners":"none","gaylord-covers":"none","gaylord-lids":"none","bulk-bag-liners":"none","bulk-bag-lifters":"none","pallet-covers":"none","pallet-corner-protectors":"none","pallet-deck-boards":"none","pallet-stringers":"none","pallet-blocks":"none","pallet-lead-boards":"none","lumber-nails":"none","lumber-screws":"none","pallet-staples":"none","wire-baskets":"none","metal-cages":"none","stretch-wrap":"none","strapping":"none","pallet-riser":"none","ibc-lids":"none","drum-lids":"none","fiber-drums":"none"}

// prettier-ignore
export const ACCESSORIES_BY_PARENT: Record<string, readonly AccessoryTypeSlug[]> = {"ibc-totes":["ibc-valves","ibc-caps","ibc-adapters","ibc-gaskets","ibc-stands","ibc-heaters","ibc-liners","ibc-lids"],"metal-drums":["drum-pumps","drum-faucets","drum-bungs","drum-liners","drum-covers","drum-heaters","drum-funnels","drum-lids"],"gaylord-boxes":["gaylord-liners","gaylord-covers","gaylord-lids"],"bulk-bags":["bulk-bag-liners","bulk-bag-lifters"],"pallets":["pallet-covers","pallet-corner-protectors","pallet-deck-boards","pallet-stringers","pallet-blocks","pallet-lead-boards","pallet-staples"],"lumber":["lumber-nails","lumber-screws"]}

// prettier-ignore
export const PRODUCT_TYPE_TRUCKLOAD_QUANTITIES: Partial<Record<MainProductTypeSlug, number>> = {}

export interface TruckCapacityDefaults {
  dryVan?: number
  flatbed?: number
  boxTruck?: number
  cargoVan?: number
}

// prettier-ignore
export const PRODUCT_TYPE_DEFAULT_TRUCK_CAPACITIES: Partial<Record<MainProductTypeSlug, TruckCapacityDefaults>> = {
  "pallets": {
    "boxTruck": 185,
    "dryVan": 520,
    "flatbed": 585,
    "cargoVan": 49
  },
  "gaylord-boxes": {
    "boxTruck": 165,
    "dryVan": 550,
    "flatbed": 523,
    "cargoVan": 44
  },
  "ibc-totes": {
    "boxTruck": 18,
    "dryVan": 60,
    "flatbed": 57,
    "cargoVan": 5
  },
  "metal-drums": {
    "boxTruck": 62,
    "dryVan": 208,
    "flatbed": 198,
    "cargoVan": 17
  },
  "plastic-drums": {
    "boxTruck": 62,
    "dryVan": 208,
    "flatbed": 198,
    "cargoVan": 17
  },
  "wood-crates": {
    "boxTruck": 60,
    "dryVan": 200,
    "flatbed": 190,
    "cargoVan": 16
  },
  "plastic-pallets": {
    "boxTruck": 156,
    "dryVan": 520,
    "flatbed": 494,
    "cargoVan": 42
  },
  "wooden-spools": {
    "boxTruck": 30,
    "dryVan": 100,
    "flatbed": 95,
    "cargoVan": 8
  },
  "plastic-crates": {
    "boxTruck": 300,
    "dryVan": 1000,
    "flatbed": 950,
    "cargoVan": 80
  },
  "bulk-bags": {
    "boxTruck": 2250,
    "dryVan": 7500,
    "flatbed": 7125,
    "cargoVan": 600
  },
  "cardboard-bales": {
    "boxTruck": 11,
    "dryVan": 38,
    "flatbed": 36,
    "cargoVan": 3
  },
  "shipping-boxes": {
    "boxTruck": 30,
    "dryVan": 100,
    "flatbed": 95,
    "cargoVan": 8
  },
  "lumber": {
    "boxTruck": 300,
    "dryVan": 1000,
    "flatbed": 950,
    "cargoVan": 80
  },
  "equipment": {
    "boxTruck": 0,
    "dryVan": 1,
    "flatbed": 1,
    "cargoVan": 1
  },
  "moving-boxes": {
    "boxTruck": 9000,
    "dryVan": 30000,
    "flatbed": 28500,
    "cargoVan": 2400
  },
  "fiber-drums": {
    "boxTruck": 62,
    "dryVan": 208,
    "flatbed": 198,
    "cargoVan": 17
  }
}

export function isMainProductType(slug: string): slug is MainProductTypeSlug {
  return isMemberOf(MAIN_PRODUCT_TYPE_SLUGS, slug)
}

export function isAccessoryType(slug: string): slug is AccessoryTypeSlug {
  return isMemberOf(ACCESSORY_TYPE_SLUGS, slug)
}

export function isProductType(slug: string): slug is ProductTypeSlug {
  return isMemberOf(PRODUCT_TYPE_SLUGS, slug)
}

export function getTruckloadQuantityForType(slug: string): number {
  if (isMainProductType(slug)) {
    return (
      PRODUCT_TYPE_TRUCKLOAD_QUANTITIES[slug] ??
      PRODUCT_TYPE_DEFAULT_TRUCK_CAPACITIES[slug]?.dryVan ??
      100
    )
  }
  return 100
}

export function getTruckDefaultsForType(slug: string): TruckCapacityDefaults | undefined {
  if (isMainProductType(slug)) {
    return PRODUCT_TYPE_DEFAULT_TRUCK_CAPACITIES[slug]
  }
  return undefined
}

export function getProductTypeBySlug(slug: string): ProductType | undefined {
  return PRODUCT_TYPES.find((p) => p.slug === slug)
}

export function getProductTypes(): readonly ProductType[] {
  return PRODUCT_TYPES
}

export function getFeaturedProductTypes(): readonly ProductType[] {
  return PRODUCT_TYPES.filter((p) => p.isFeatured)
}

export function getNonFeaturedProductTypes(): readonly ProductType[] {
  return PRODUCT_TYPES.filter((p) => !p.isFeatured)
}

export function getDimensionTypeForType(slug: ProductTypeSlug) {
  return PRODUCT_TYPE_DIMENSION_TYPES[slug]
}

export function getDisplayName(slug: ProductTypeSlug, plural = false): string | undefined {
  const names = PRODUCT_TYPE_DISPLAY_NAMES[slug]
  return plural ? names?.plural : names?.singular
}

export function getActiveProductSlugs(): MainProductTypeSlug[] {
  return [...MAIN_PRODUCT_TYPE_SLUGS]
}

export function formatProductTypeSlug(slug: string | null | undefined): string {
  if (!slug) return 'Products'
  return slug
    .replace(/^buy-/, '')
    .replace(/^sell-/, '')
    .replace(/^recycle-/, '')
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export interface AccessoryGroup {
  parentSlug: string
  parentName: string
  parentIconUrl: string | null
  accessories: AccessoryType[]
}

export interface CategorizedProductTypes {
  mainTypes: ProductType[]
  accessoryGroups: AccessoryGroup[]
}

export function getCategorizedProductTypes(): CategorizedProductTypes {
  const mainTypes = [...PRODUCT_TYPES]
  const accessoryGroups: AccessoryGroup[] = []

  for (const [parentSlug, accessorySlugs] of Object.entries(ACCESSORIES_BY_PARENT)) {
    const parent = PRODUCT_TYPES.find(pt => pt.slug === parentSlug)
    if (parent) {
      accessoryGroups.push({
        parentSlug,
        parentName: parent.displayName,
        parentIconUrl: parent.iconUrl,
        accessories: accessorySlugs
          .map(slug => ACCESSORY_TYPES.find(at => at.slug === slug))
          .filter((at): at is AccessoryType => at !== undefined)
      })
    }
  }

  return { mainTypes, accessoryGroups }
}

export function getAccessoryTypeBySlug(slug: string): AccessoryType | undefined {
  return ACCESSORY_TYPES.find((a) => a.slug === slug)
}

export const DIMENSION_FIELD_NAMES = ['length', 'width', 'height', 'capacity'] as const
export const RFQ_ROOT_FIELD_NAMES = ['estimatedWeightLbs', 'budgetCents', 'askingPriceCents'] as const

export function isDimensionField(name: string): boolean {
  return isMemberOf(DIMENSION_FIELD_NAMES, name)
}

export function isRfqRootField(name: string): boolean {
  return isMemberOf(RFQ_ROOT_FIELD_NAMES, name)
}
